import React from 'react';
import PropTypes from 'prop-types';

const CarouselCard = ({ card }) => {
  const { name, imagePath, header, text } = card;
  return (
    <div className="sl-meter-carouselcard">
      <img src={imagePath} alt={name} className="sl-meter-carouselcard__img" />
      <h5 className="sl-meter-carouselcard__header">{header}</h5>
      <span className="sl-meter-carouselcard__text">{text}</span>
    </div>
  );
};

CarouselCard.propTypes = {
  card: PropTypes.shape({
    name: PropTypes.string,
    imagePath: PropTypes.string,
    header: PropTypes.string,
    text: PropTypes.string,
  }),
};

CarouselCard.defaultProps = {
  card: PropTypes.shape({
    name: null,
    imagePath: null,
    header: null,
    text: null,
  }),
};

export default CarouselCard;
